import { useAction, useAtom } from '@reatom/npm-react'

import { useTranslation } from '@root/shared/localization'
import { ConfirmDrawer } from '@root/shared/ui-kit'

import { logoutAction, logoutDialogAtom } from '../atoms'

export const LogoutDrawer = () => {
  const { t } = useTranslation()
  const logout = useAction(logoutAction)
  const [isOpen, setIsOpen] = useAtom(logoutDialogAtom)

  return (
    <ConfirmDrawer
      header={t('auth.log-out')}
      intent="error"
      open={isOpen}
      onOpenChange={setIsOpen}
      description={t('auth.logout-message')}
      onCancel={() => setIsOpen(false)}
      confirmLabel={t('auth.log-out')}
      onConfirm={logout}
    />
  )
}
